import { Injectable } from '@angular/core';

import { MessagingEnvironmentService } from '../../../core/services/messaging-environment.service';
import { LoggerService } from '../../../core/services/logger.service';

@Injectable()
export class SoundsService {
  // ringtone: HTMLAudioElement;
  // joinSound: HTMLAudioElement;
  // leftSound: HTMLAudioElement;
  // newMessage: HTMLAudioElement;
  // sentMessage: HTMLAudioElement;

  constructor(private env: MessagingEnvironmentService, private logger: LoggerService) {
    this.loadSounds();
  }

  loadSounds() {
    // this.ringtone = new Audio(`${this.env.env.assetsNgxMessaging}/sounds/ringtone.mp3`);
    // this.joinSound = new Audio(`${this.env.env.assetsNgxMessaging}/sounds/join.mp3`);
    // this.leftSound = new Audio(`${this.env.env.assetsNgxMessaging}/sounds/left.mp3`);
    // this.newMessage = new Audio(`${this.env.env.assetsNgxMessaging}/sounds/recieved.mp3`);
    // this.sentMessage = new Audio(`${this.env.env.assetsNgxMessaging}/sounds/sent.mp3`);
    // this.joinSound.load();
    // this.leftSound.load();
    // this.ringtone.load();
    // this.newMessage.load();
    // this.sentMessage.load();
  }

  playNewMessage(): void {
    try {
      // this.newMessage.play();
    } catch {
      this.logger.debug('Failed to play new message sound');
    }
  }

  playSentMessage(): void {
    try {
      // this.sentMessage.play();
    } catch {
      this.logger.debug('Failed to play sent message sound');
    }
  }

  playRingtone(): void {
    try {
      // this.ringtone.play();
    } catch {
      this.logger.debug('Failed to play ringtone sound');
    }
  }
}
